import { getRoute } from "../client"
import type { NotificationFeedDto } from "../../shared/engagementTypes"

export const notificationsRoute = getRoute<NotificationFeedDto>("/api/notifications")
